import { h, render } from "preact";
import { StorageProvider, useItemsStorage } from "./useItemsStorage";
import { useFetchItems } from "./useFetchItems";

export function HistoryPage() {
  const { history } = useItemsStorage();
  const page = useFetchItems({ type: "history", ids: history });
  return page.length ? (
    <div dangerouslySetInnerHTML={{ __html: page }} />
  ) : null;
}

const historyRenderer = document.getElementById("history");
if (historyRenderer) {
  render(h(StorageProvider, null, h(HistoryPage, null)), historyRenderer);
}
